if (process.env.REACT_APP_SITE_CODE === 'fx') {
  module.exports = require('./type.fx/style')
} else if (process.env.REACT_APP_SITE_CODE === 'lsav') {
  module.exports = require('./type.lsav/style')
} else if (process.env.REACT_APP_SITE_CODE === 'xlav') {
  module.exports = require('./type.xlav/style')
} else {
  module.exports = require('./type.shy/style')
}
